<template>
  <div>
    <div class="flex mt-2.5 items-center">
      <div
        class="w-full rounded-lg flex flex-col flex-grow justify-between items-center bg-black-card relative p-2.5 border border-transparent border-solid transition-all"
        :class="{
          '!border-[#838383]': hover || focus,
          '!border-red-600': error.show
        }"
        @mousemove="() => (hover = true)"
        @mouseleave="() => (hover = false)"
      >
        <div class="w-full flex" @keydown.stop>
          <span
            v-if="showLabel"
            class="flex-shrink-0 mr-2.5 leading-tight text-[14px]"
            >{{ label }}</span
          >
          <a-input
            class="w-full flex-grow bg-[rgb(49,49,49)] outline-0 border-none p-0 leading-tight"
            :disabled="disabled"
            :value="value"
            @change="(e: any) => emits('change', e.target.value)"
          />
        </div>
      </div>
      <!-- <template> -->
      <div class="flex justify-between items-center">
        <div
          v-if="showAdd"
          class="cursor-pointer mx-2.5"
          @click.stop="emits('add')"
        >
          <icon :icon="'add.svg'" :width="14" :height="14" fill="none" />
        </div>
        <div
          v-if="showDelete"
          class="cursor-pointer mx-2.5"
          @click.stop="emits('delete')"
        >
          <icon :icon="'minus.svg'" :width="14" :height="14" fill="none" />
        </div>
        <div
          v-if="showSelect"
          class="w-5 h-5 p-[2px] bg-[#FA683A]/[0.1] border border-[#E66138] rounded-xl cursor-pointer mx-2.5"
          @click.stop="emits('select')"
        >
          <div
            class="w-full h-full rounded-xl"
            :class="{
              'bg-[#E66138]': selected
            }"
          ></div>
        </div>
      </div>
    </div>
    <div v-if="error.show" class="text-red-600 mt-[10px]">{{ error.msg }}</div>
  </div>
</template>

<script setup lang="tsx">
import { isEmojiCharacter } from '@/utils/richtext.util';
import { ref, watch } from 'vue';

const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  showAdd: {
    type: Boolean,
    default: false
  },
  showDelete: {
    type: Boolean,
    default: false
  },
  showSelect: {
    type: Boolean,
    default: false
  },
  selected: {
    type: Boolean,
    default: false
  },
  showLabel: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: ''
  },
  max: {
    type: Number,
    default: 100000
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const hover = ref(false);
const focus = ref(false);
const error = ref({
  show: false,
  msg: ''
});

const emits = defineEmits<{
  (event: 'add'): void;
  (event: 'delete'): void;
  (event: 'select'): void;
  (event: 'change', val: string): void;
}>();
watch(
  () => [props.max, props.value, props.required],
  ([max, value, required]) => {
    const vailadeInput = (
      val: string,
      max: number,
      required: boolean,
    ): boolean => {
      const strs = ['%s', '%d', '%f', '%0.2f'];
      if (val.length > max) {
        error.value = {
          show: true,
          msg: `不能超过${max}个字符`
        };
      } else if (val.length <= 0 && required) {
        error.value = {
          show: true,
          msg: `内容不能为空`
        };
      } else {
        const str = strs.find((it) => val.indexOf(it) !== -1);
        if (str) {
          error.value = {
            show: true,
            msg: `不支持${str}的输入`
          };
        } else if (isEmojiCharacter(val)) {
          error.value = {
            show: true,
            msg: `不支持表情符号输入`
          };
        } else {
          error.value = {
            show: false,
            msg: ''
          };
        }
      }
      return !error.value.show;
    };
    vailadeInput(value as string, max as number, !!required);
  },
  { immediate: true }
);
</script>
